(function(AUFHAUSEN) {

    var _onToggle = function() {
        var _self = this;

        _self.headerElem.classList.toggle('header--open');
        document.body.classList.toggle('header-open');

        _self.mobileOpen = !_self.mobileOpen;
    };

    var _onPrimaryItemClick = function(evt) {
        var _self = this;
        var item = evt.currentTarget;
        var secondary = item.parentNode.nextElementSibling;

        evt.preventDefault();

        secondary.classList.toggle('nav__secondary-container--open');
    };

    AUFHAUSEN.Menu = function() {
        var _self = this;

        _self.headerElem = document.querySelector('.js-header');
        _self.mobileToggleBtn = _self.headerElem.querySelector('.js-menu-toggle');
        _self.primaryElems = _self.headerElem.querySelectorAll('.nav__primary-item.menu-item-has-children > a');

        _self.mobileOpen = false;

        _self.init();
    };

    AUFHAUSEN.Menu.prototype.init = function() {
        var _self = this;

        _self.mobileToggleBtn.addEventListener('click', function() {
            _onToggle.call(_self);
        });

        for (var i = 0; i < _self.primaryElems.length; i++) {
            _self.primaryElems[i].addEventListener('click', function(evt) {
                _onPrimaryItemClick.call(_self, evt);
            });
        }
    };

})(AUFHAUSEN);